import React, { useState, useEffect } from "react";
import { colors } from "../../../../../themes/Colors";
import BaseButtons from "../../../base-buttons/BaseButtons";

const VehicleCard = ({
  productName,
  onManageClick,
  registrationNr,
  vin_nr,
  licenceNr,
  engineNr,
  make,
  series,
  notList,
  image,
  selector,
  onSelectClcik,
  type,
  width,
  expireDate,
  index,
}) => {
  const [hover, setHover] = useState(false);
  const [imageLink, setImageLink] = useState(null);
  const ColorSwitch = () => {
    if (type === "consumer") {
      return colors.greenLight;
    } else if (type === "org") {
      return colors.orangeDark;
    } else if (type === "agency") {
      return colors.primaryBlue;
    }
  };
  //   register_nr  (7)

  // licence_nr (9)

  // vin_nr (17)

  // engine_nr (20)

  // make (50) this is a look up of the make table

  // series (100) this is a look up of the series table of series with the make from above.
  const GetVehicleMake = async () => {
    try {
      const response = await fetch(
        process.env.REACT_APP_BACKEND_URL +
          "/userVehicles/getVehicleMakeImageLink",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            // Authorization: `bearer ${token}`,
          },
          body: JSON.stringify({
            makeName: make,
          }),
        }
      );

      const respnseData = await response.json();
      if (respnseData.success) {
        setImageLink(respnseData.makeImage);
        // setToastPop(true);
      }
    } catch (err) {
      console.log("text", err);
    }
  };

  useEffect(() => {
    if (make) {
      GetVehicleMake();
    }
  }, [make]);
  return (
    <div
      onClick={onManageClick ? onManageClick : null}
      onMouseOver={() => setHover(true)}
      onMouseOut={() => setHover(false)}
      style={{
        height: "90%",
        width: 300,
        display: "flex",
        flexDirection: "column",
        cursor: "pointer",
        backgroundColor: colors.greenLight,
        color: colors.white,
        borderRadius: 20,
        marginLeft: 25,
        borderStyle: "solid",
        borderWidth: 2,
        WebkitBoxShadow: "-5px 3px 7px 2px #00000050",
      }}
    >
      <div style={{ flex: 0.1 }}></div>
      <div
        onClick={selector ? onSelectClcik : null}
        style={{
          flex: 0.9,
          backgroundColor: hover ? ColorSwitch() : null,
          borderRadius: 10,
          WebkitBoxShadow: hover ? "-5px 5px 15px -1px #00000070" : null,
          transition: "all 0.7s",
          position: "relative",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          alignContent: "center",
          width: "100%",
          // borderStyle: "solid",
          // borderWidth: notList ? 3 : 0,
          // borderColor: colors.greenLight,
          padding: width > 899 ? 5 : 0,
        }}
      >
        <div
          style={{
            position: "absolute",
            top: 4,
            transition: "all 0.5s",
            left: -30,
            backgroundColor: colors.white,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            overflow: "hidden",
            height: 80,
            width: 80,
            borderRadius: 20,
            WebkitBoxShadow: "0px 0px 7px 2px #00000050",
          }}
        >
          <img
            alt="icon"
            src={imageLink}
            style={{
              padding: 10,
              width: 80,
              zIndex: 3,
              // borderRadius: 20,
            }}
          />
        </div>
        <div style={{ width: "100%", marginRight: 10 }}>
          {/* <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "90%",
                textAlign: "left",
                fontSize: hover ? 16 : 12,
                fontWeight: "bolder",
                // marginTop: 50,
                marginLeft: 70,
                color: colors.white,
                transition: "all 0.25s",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>REGISTER NR</div>
              {registrationNr}
            </div>
          </div> */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "90%",
                textAlign: "left",
                fontSize: hover ? 20 : 20,
                // marginTop: 5,
                marginLeft: 70,
                color: colors.white,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
              }}
            >
              {licenceNr}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                marginTop: 5,
                marginLeft: 70,
                color: colors.white,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>MAKE</div>
              {make}
            </div>
          </div>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                marginTop: 5,
                marginLeft: 70,
                color: colors.white,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>SERIES</div>
              {series}
            </div>
          </div>
          {/* <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              style={{
                width: "90%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                marginTop: 5,
                color: colors.white,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
                marginLeft: 70,
              }}
            >
              <div style={{ fontSize: 9, opacity: 0.5 }}>VIN NR</div>
              {vin_nr}
            </div>
          </div> */}
        </div>

        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginTop: 20,
            flexDirection: "column",
          }}
        >
          <div
            style={{
              // width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              right: 12,
              bottom: 12,
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "left",
                fontSize: hover ? 12 : 12,
                // marginTop: 5,
                color: colors.white,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
                marginTop: -15,
                opacity: 0.7,
              }}
            >
              {expireDate}
            </div>
          </div>
        </div>
        <div
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            // marginTop: 20,
            flexDirection: "column",
          }}
        >
          <div
            style={{
              // width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "absolute",
              right: 15,
              top: 15,
            }}
          >
            <div
              style={{
                width: "100%",
                textAlign: "left",
                fontSize: 16,
                // marginTop: 5,
                color: colors.white,
                transition: "all 0.25s",
                fontWeight: "bold",
                display: "flex",
                flexDirection: "column",
                marginTop: -15,
                // opacity: 0.7,
              }}
            >
              {index}
            </div>
          </div>
        </div>
        {notList ? null : (
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center",
              marginTop: 20,
              position: "absolute",
              bottom: width > 899 ? (hover ? -45 : -50) : hover ? -25 : -20,
              transition: "all 0.25s",
            }}
          ></div>
        )}
      </div>
    </div>
  );
};

export default VehicleCard;
